import {Base} from "@/api/Base"

export class OtherAdd extends Base {
    path = "other/add"
}